import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import AddressCard from "src/Components/Cards/AddressCard";
import DrawerTitle from "src/Components/Drawer/DrawerTitle";
import GradientBtn from "src/Components/WebsiteComponents/GradientBtn";
import {
  getShippingAddresses,
  handleAddressSelect,
  setShippingAddresses,
} from "src/helpers/helperFunctions";
import httpRequest from "src/helpers/httpRequest";
import { AllTabType, IAddressData } from "src/types/GlobalInterfaces";
import { RootState } from "src/Store/store";
import { toast } from "react-toastify";
import { setCurrentAddress } from "src/Store/cartSlice";
import { Loader } from "lucide-react";
import NoItemUI from "src/Components/NoItemUI";
import NoItemAddressImg from "src/assets/images/not-data/no-address.png";

interface IProps {
  setActiveTab?: (tab: AllTabType) => void;
  onBack?: () => void;
  onSelectAddress?: (address: IAddressData | null) => void;
  setIsEditAddress?: (isEditAddress: boolean) => void;
  setPickAddress?: (pickAddress: any) => void;
  addresses: IAddressData[];
  getLoader: boolean;
  onReload?: () => void;
}

const ManageAddressSection = ({
  setActiveTab,
  onBack,
  onSelectAddress,
  setIsEditAddress,
  setPickAddress,
  addresses,
  getLoader,
  onReload,
}: IProps) => {
  const dispatch = useDispatch();
  const { address } = useSelector((state: RootState) => state.cartSlice);
  const [selectedAddress, setSelectedAddress] = useState<IAddressData | null>(
    null
  );
  const [selectAddressLoader, setSelectAddressLoader] =
    useState<boolean>(false);

  useEffect(() => {
    if (address) {
      setSelectedAddress(address as IAddressData);
    }
  }, [address]);

  const handleSelectAddress = async (address: IAddressData) => {
    setSelectAddressLoader(true);
    let isSuccess = await handleAddressSelect(address?._id || "");
    if (isSuccess) {
      dispatch(setCurrentAddress(address as IAddressData));
      onSelectAddress?.(address);
    }
    setSelectAddressLoader(false);
  };
  return (
    <>
      {selectAddressLoader && (
        <div className="w-full h-full fixed top-0 left-0 bg-black/50 z-50 flex items-center justify-center">
          <Loader className="w-10 h-10 animate-spin" />
        </div>
      )}
      <DrawerTitle
        title="Addresses"
        onBack={onBack}
        backBtn
        id={"back-button"}
      />
      <div className="w-full side-bar-padding-3 side-bar-gap-2 flex flex-col gap-2">
        {getLoader ? (
          <AddressCard
            key={"address"}
            address={null as any}
            onEdit={() => {}}
            onSelect={() => {}}
            onDelete={() => {}}
            isActive={false}
            skeleton
          />
        ) : addresses.length > 0 ? (
          addresses.map((address, index) => (
            <AddressCard
              index={index}
              key={address._id}
              address={address}
              onEdit={() => {
                setPickAddress?.(address);
                setIsEditAddress?.(true);
                setActiveTab?.("AddressForm");
              }}
              onSelect={() => {
                handleSelectAddress(address);
              }}
              onDelete={() => {
                setShippingAddresses(null);
                if (selectedAddress?._id === address._id) {
                  onSelectAddress?.(null);
                }
                onReload?.();
              }}
              isActive={selectedAddress?._id === address._id}
            />
          ))
        ) : (
          <div className="w-full mt-5">
            <NoItemUI
              text="No addresses found"
              text2="Add a new address to continue"
              iconImagePath={NoItemAddressImg}
              onButtonClick={() => {
                setPickAddress?.(null);
                setIsEditAddress?.(false);
                setActiveTab?.("AddNewAddress");
              }}
              ButtonText="Add a New Address"
              buttonId="add-new-address-btn"
            />
          </div>
        )}
        {addresses.length > 0 && (
          <div className="w-full fixed bottom-0 left-0 bg-drawer px-2 2xl:px-3 py-1 2xl:py-2 shadow-all">
            <GradientBtn
              id={"AddNewAddress-button"}
              ButtonText="Add a New Address"
              extraClass="w-full"
              onPress={() => {
                setPickAddress?.(null);
                setIsEditAddress?.(false);
                setActiveTab?.("AddNewAddress");
              }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default ManageAddressSection;
